import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './AddColumnButton.scss';
const AddColumnButton = ({ className, onClick, disabled, biData })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(BiButton, {
        onClick: onClick,
        disabled: disabled,
        className: classnames(s['edit-button'], disabled && s['disabled'], className),
        "data-role": "edit-control",
        "aria-label": t('gruser.widgetbox.button.addColumn'),
        biData: biData
    }, /*#__PURE__*/ React.createElement(AddIcon, {
        size: IconSize.MEDIUM,
        className: s['icon'],
        condensed: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['edit-button-text']
    }, t('gruser.widgetbox.button.addColumn')));
};
AddColumnButton.displayName = 'AddColumnButton';
export default AddColumnButton;
